/**
 * Filters a list of route configs by tenant dashboard feature flags.
 *
 * Untagged routes (no `feature`) are always kept. A tagged route is kept unless
 * its flag is explicitly `false`, so a missing or `undefined` flag still renders
 * the route (fail-open, mirroring `useTeacherDashboardFeatures`).
 *
 * @param {Array<{ feature?: string }>} routes
 * @param {Record<string, boolean>} features
 * @returns {Array}
 */
export function filterRoutesByFeatures(routes, features) {
  return routes.filter((route) => !route.feature || features[route.feature] !== false);
}
